const findRoute = [
    {
        path: '',
        name: 'findList',
        meta: { controlField: 'findMenu' },
        component: resolve => require(['@/views/find/findView'], resolve),
    },
    {
        path: 'findSearch',
        name: 'findSearch',
        meta: { controlField: 'findMenu' },
        component: resolve => require(['@/views/find/searchFind'], resolve),
    }
]
export default findRoute